import { gql } from '@apollo/client/core';

const LOGIN = gql`
  mutation OnLogin($identifier: String!, $password: String!) {
    login(input: { identifier: $identifier, password: $password }) {
      jwt
      user {
        id
        username
      }
    }
  }
`;

export default LOGIN;
